import { render } from "./Settings.vue?vue&type=template&id=2914927b&bindings={\"config\":\"setup\",\"isImportAvailable\":\"setup\",\"prettyDuration\":\"setup\",\"toggleConfigKey\":\"setup\",\"importAvatars\":\"setup\",\"exportAvatars\":\"setup\"}"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
script.render = render

export default script